// extracted by mini-css-extract-plugin
module.exports = {"renderWrapper":"b_b","err":"b_c"};